import React from "react";
import { ThemeContext } from "./ThemeContext";

export const ThemeProvider = ({ children }) => {
  const theme = {
    primaryColor: "#033AB5",
    secondaryColor: "#FF6200",
    textColor: "#FFFFFF",
    className: "unleash-blue",
  };

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};
